const LoginInput =(props)=>{
    return (
        <div className="mb-3">
            <input className="form-control" type={props.type} name={props.name} onChange={props.onChange}
                   placeholder={props.placeholder} required/>
        </div>
    );
}
export default LoginInput;